import modulesIcon from './modules.svg';
import usersIcon from './users.svg';
import productsIcon from './products.svg';
import categoriesIcon from './categories.svg';
import customersIcon from './customers.svg';
import discountCodesIcon from './discount-codes.svg';
import homeConfigIcon from './home-config.svg';
import catalogsIcon from './catalogs.svg';
import teamIcon from './team.svg';
import locationsIcon from './locations.svg';
import ordersIcon from './orders.svg';
import translateIcon from './translate.svg';
import materialsIcon from './materials.svg';
import addsIcon from './adds.svg';
import attributesIcon from './attributes.svg';
import familyAndFriendsIcon from './family-and-friends.svg';
import claimInfoIcon from './claim-info.svg';
import pagesIcon from './pages.svg';
import newsletterIcon from './newsletter.svg';
import stockClientsIcon from './stock-clients.svg';
import vindPagesIcon from './vind-pages.svg';
import synchronizationIcon from './synchronization.svg';
import priceListIcon from './price-list.svg';
import curaIcon from './cura.svg';
import customersApiUsageIcon from './customers-api-usage.svg';
import apiAnaliticsIcon from './api-analitics.svg';
import globalApiAnaliticsIcon from './global-api-analitics.svg';
import hornbachStockIcon from './hornbach-stock.svg';
import logoutIcon from './logout.svg';

// Sidebar menu icons, keyed by module name as returned from the API
const sidebarIcons = {
    'Modules': modulesIcon,
    'Users': usersIcon,
    'Products': productsIcon,
    'Categories': categoriesIcon,
    'Customers': customersIcon,
    'Discount codes': discountCodesIcon,
    'Home config': homeConfigIcon,
    'Catalogs': catalogsIcon,
    'Team': teamIcon,
    'Locations': locationsIcon,
    'Orders': ordersIcon,
    'Translate': translateIcon,
    'Materials': materialsIcon,
    'Adds': addsIcon,
    'Attributes': attributesIcon,
    'Family & Friends': familyAndFriendsIcon,
    'Claim Info': claimInfoIcon,
    'Pages': pagesIcon,
    'Newsletter': newsletterIcon,
    'Stock Clients': stockClientsIcon,
    'Vind Pages': vindPagesIcon,
    'Synchronization': synchronizationIcon,
    'Price list': priceListIcon,
    'Cura': curaIcon,
    'Customers API usage': customersApiUsageIcon,
    'Api Analitics': apiAnaliticsIcon,
    'Global Api Analitics': globalApiAnaliticsIcon,
    'Hornbach Stock': hornbachStockIcon,
    'Logout': logoutIcon,
};

export const getSidebarIcon = (name) => name ? sidebarIcons[name.trim()] : null;

export default sidebarIcons;
